import type { Theme } from '@mui/material/styles';

export const ADMIN_STAT_CHART_MAX_BAR_SIZE = 80;

const POSITIVE_GUEST_USER_LABELS = new Set(['Active', 'Complete']);

type ReportChipPaletteKey = 'green' | 'red' | 'yellow' | 'gray' | 'blue';

export function getReportChipPaletteColor(
    tone: ReportChipPaletteKey,
    theme: Theme,
): string {
    return theme.palette[tone].main;
}

export function getReportChipSx(tone: ReportChipPaletteKey, theme: Theme) {
    const color = getReportChipPaletteColor(tone, theme);

    return {
        color,
        borderColor: color,
    };
}

export function getBookingStatusChipTone(status: string): ReportChipPaletteKey {
    if (status === 'completed') return 'green';
    if (status === 'cancelled') return 'red';
    if (status === 'approved') return 'yellow';
    if (status === 'declined') return 'gray';
    return 'blue';
}

export function getJobStatusChipTone(status: string): ReportChipPaletteKey {
    if (status === 'completed') return 'green';
    if (status === 'cancelled' || status === 'declined') return 'red';
    if (status === 'accepted') return 'yellow';
    return 'blue';
}

export function getAttendeeStatusChipTone(
    status: string,
): ReportChipPaletteKey {
    if (status === 'accepted') return 'green';
    if (status === 'declined') return 'red';
    return 'yellow';
}

export function getRsvpSentChipTone(isSent: boolean): ReportChipPaletteKey {
    return isSent ? 'green' : 'gray';
}

export function getPaidStatusChipTone(isPaid: boolean): ReportChipPaletteKey {
    return isPaid ? 'green' : 'yellow';
}

export function getGuestUserBarColor(label: string, theme: Theme): string {
    return POSITIVE_GUEST_USER_LABELS.has(label)
        ? theme.palette.green.main
        : theme.palette.red.main;
}
